module.exports = __webpack_public_path__ + "img/logo.f21de846.png";